import type { RouteLocationNormalized } from "vue-router";

export default [
  {
    path: "/backoffice/settings/manage-codes",
    name: "ManageCodes",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Settings" },
        { label: "Fields" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "settings" */ "@/views/backoffice/settings/ManageCodes.vue"
      ),
  },
  {
    path: "/backoffice/settings/manage-codes/create",
    name: "CreateCode",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Settings" },
        { label: "Fields", to: "/backoffice/settings/manage-codes" },
        { label: "Create" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "settings" */ "@/views/backoffice/settings/CreateCode.vue"
      ),
  },
  {
    path: "/backoffice/settings/manage-codes/:id",
    name: "CodeDetail",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Settings" },
        { label: "Fields", to: "/backoffice/settings/manage-codes" },
        { label: "Detail" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "settings" */ "@/views/backoffice/settings/CodeDetail.vue"
      ),
  },
  {
    path: "/backoffice/settings/manage-codes/:id/edit",
    name: "EditCode",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Settings" },
        { label: "Fields", to: "/backoffice/settings/manage-codes" },
        { label: "Edit" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "settings" */ "@/views/backoffice/settings/EditCode.vue"
      ),
  },
  {
    path: "/backoffice/settings/manage-codes/:id/add-value",
    name: "AddCodeValue",
    meta: {
      requiresAuth: true,
      breadcrumb: (route: RouteLocationNormalized) => [
        { label: "BackOffice", to: "/" },
        { label: "Settings" },
        { label: "Fields", to: "/backoffice/settings/manage-codes" },
        { label: "Code Detail", to: `/backoffice/settings/manage-codes/${route.params.id}` },
        { label: "Add Value" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "settings" */ "@/views/backoffice/settings/AddCodeValue.vue"
      ),
  },
  {
    path: "/backoffice/settings/manage-codes/:id/edit-value/:valueId",
    name: "EditCodeValue",
    meta: {
      requiresAuth: true,
      breadcrumb: (route: RouteLocationNormalized) => [
        { label: "BackOffice", to: "/" },
        { label: "Settings" },
        { label: "Fields", to: "/backoffice/settings/manage-codes" },
        { label: "Code Detail", to: `/backoffice/settings/manage-codes/${route.params.id}` },
        { label: "Edit Value" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "settings" */ "@/views/backoffice/settings/EditCodeValue.vue"
      ),
  },
];
